import React, { forwardRef } from 'react'
import { makeStyles } from '@mui/styles'

import { ClassesType } from '../../types'
import TextWithTooltip, { TextWithTooltipProps } from '../TextWithTooltip'
import PuiTextField, { PuiTextFieldProps } from './PuiTextField'

const useStyles = makeStyles(
  theme => ({
    input: {
      fontSize: '1.4rem',
      [theme.breakpoints.down('md')]: {
        fontSize: '1.6rem',
      },
      scrollbarWidth: 'none', // firefox
      '&::-webkit-scrollbar': {
        // webkit
        display: 'none',
      },
    },
    adornment: {
      alignSelf: 'flex-end',
      marginBottom: theme.spacing(1),
      marginRight: theme.spacing(1),
    },
    progress: {},
  }),
  { name: 'PuiTextArea' },
)

export interface PuiTextAreaProps extends Omit<PuiTextFieldProps, 'classes'> {
  readonly classes?: ClassesType<typeof useStyles>
  readonly labelProps?: TextWithTooltipProps
  readonly showColon?: boolean
}

const PuiTextArea = forwardRef<HTMLDivElement, PuiTextAreaProps>(
  function PuiTextArea(
    {
      label,
      minRows = 3,
      InputProps,
      labelProps,
      classes: classesProp,
      showColon = true,
      ...rest
    },
    ref,
  ) {
    const classes = useStyles({ classes: classesProp })

    return (
      <>
        {label && (
          <TextWithTooltip strong variant="subheading3" {...labelProps}>
            {`${label}${showColon ? ':' : ''}`}
          </TextWithTooltip>
        )}
        <PuiTextField
          fullWidth
          multiline
          InputProps={{
            inputProps: {
              className: classes.input,
            },
            ...InputProps,
          }}
          ProgressAdornmentProps={{
            classes: {
              adornment: classes.adornment,
              progress: classes.progress,
            },
          }}
          id={`${label}-input`}
          minRows={minRows}
          ref={ref}
          type="text"
          variant="outlined"
          {...rest}
        />
      </>
    )
  },
)

export default PuiTextArea
